// @core/api/endpoints/localization/list_locales.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLocalesResponse,
} from '../../../types/localization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/localization';

/**
 * List locales
 * Returns all locales defined on the platform. Supports filtering by status.
 * @public This endpoint does not require authentication
 */
export async function ListLocales(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLocalesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/locales`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListLocalesResponse>(requestPath, { ...requestOptions, params });
}
